import { render, staticRenderFns } from "./view-field-card.vue?vue&type=template&id=2ef6ce38&scoped=true&"
import script from "./view-field-card.vue?vue&type=script&lang=js&"
export * from "./view-field-card.vue?vue&type=script&lang=js&"
import style0 from "./view-field-card.vue?vue&type=style&index=0&id=2ef6ce38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6ce38",
  null
  
)

export default component.exports